import type { SceneContent } from '../../../presentation/types';

/** Source: docs/product-content/MINT-BUSINESS.md (positioning only; no feature claims). */
export const mintBusiness: SceneContent = {
  id: 'mint-business',
  shortLabel: 'BUSINESS',
  title: 'MINT Business',
  seconds: 30,
  brand: 'mint-business',
  bridgeIn: (context) => (context.isEnabled('mint-travel') ? 'And the same core, applied to business.' : 'Back to the MINT core, and another branch.'),
  atmosphere: (step) => ({ pattern: step >= 1 ? 'inward' : 'drift', density: 0.22, opacity: 0.06, cameraZ: 14.2 }),
  script: {
    title: 'MINT Business',
    onScreen: ['ORGANISATION · PEOPLE · CUSTOMERS · OPERATIONS · MARKET · PERFORMANCE · DECISIONS', 'BUSINESS GENERATES INFORMATION EVERYWHERE.', 'CONNECTED THROUGH MINT.', 'MINT BUSINESS', 'MINT intelligence specialised for business context.'],
    visual: 'The MINT core in the centre, with any other specialisations faint in the background. Business concepts (organisation, people, customers, operations, market, performance, decisions) drift separately, then connect into MINT. A new branch activates and MINT Business is named.',
    narration: [
      'Every business generates information everywhere: across the organisation, its people, customers, operations, the market, performance and the decisions it has to make.',
      'Instead of treating those as unrelated pieces, MINT brings the relevant context together around the questions the business needs to answer.',
      'That is MINT Business: the same intelligence foundation, specialised for business context. The point is not a list of features. It is one foundation, specialised for a different environment.',
    ],
    presenterNotes: [
      'Business concepts appear separately. "Business generates information everywhere."',
      'They connect into MINT. "Connected through MINT."',
      'The branch activates. Name MINT Business. Not a CRM; do not list features.',
    ],
  },
};
